import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';
import { Link } from 'react-router-dom';

import {
  HighlightsContent,
  HighlightsContentContainer,
  ImageContainer,
  OwnerHighlightsContainer,
} from './highlightsSection.styled';

const HighlightsSection = () => {
  return (
    <OwnerHighlightsContainer>
      <ImageContainer>
        <Image height={1500} src="https://static.patacdn.net/images/image-lady-grooming-dog-wide.png" />
      </ImageContainer>
      <HighlightsContentContainer>
        <HighlightsContent>
          <h2>Are you a pet groomer, dog trainer, walker or sitter?</h2>

          <p>
            Join Pata, the subscription-free booking platform built for pet care pros. Save time with online bookings,
            protect your income with deposits, and manage appointments in one simple system.
          </p>

          <Link to="/business">
            <Button>Learn more</Button>
          </Link>
        </HighlightsContent>
      </HighlightsContentContainer>
    </OwnerHighlightsContainer>
  );
};

export default HighlightsSection;
